import React, { Suspense, useEffect } from 'react';

import { Outlet, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

import {
  FEATURE_FLAG_NAMES,
  useFeatureFlag,
  useFeatureFlagsReady
} from '../../hooks/useFeatureFlag';
import { syncDesignToRoute } from '../../utils/design';
import { useClassicPagesLight } from '../../theme/forcedColorScheme';

import AgentPanel from '../AgentPanel';
import AppTopBar from './AppTopBar';
import ErrorBoundary from '../ErrorBoundary';
import RouteLoading from '../RouteLoading';
import WorkflowStepper from './WorkflowStepper';
import WorkflowToolbar from './WorkflowToolbar';
import { WorkflowChromeProvider } from './WorkflowChromeContext';
import { PeriodRunProvider } from './PeriodRun/PeriodRunContext';
import RunBanner from './PeriodRun/RunBanner';
import RunOverlay from './PeriodRun/RunOverlay';
import RunSheets from './PeriodRun/RunSheets';
import RunSummary from './PeriodRun/RunSummary';

import { Container, Content, Wrapper } from './style';

const Layout = () => {
  const { pathname } = useLocation();
  const isV2UI = useFeatureFlag(FEATURE_FLAG_NAMES.V2_UI);
  const flagsReady = useFeatureFlagsReady();
  useClassicPagesLight();

  // On /report-v2 the switch reads "on"; without this, the stored setting could still say classic.
  useEffect(() => {
    if (flagsReady && isV2UI) syncDesignToRoute(pathname);
  }, [pathname, isV2UI, flagsReady]);

  return (
    <WorkflowChromeProvider>
      {/* Above the outlet, because the run it holds walks from one stage page to the next and must
          not be unmounted on the way. */}
      <PeriodRunProvider>
        <Container>
          <Wrapper>
            <AppTopBar />
            <RunBanner />
            <WorkflowStepper />
            <WorkflowToolbar />
            <Content open={false}>
              <ErrorBoundary componentName="Route">
                <Suspense fallback={<RouteLoading />}>
                  <Outlet />
                </Suspense>
              </ErrorBoundary>
            </Content>
            <RunOverlay />
            <RunSheets />
            <RunSummary />
            <div className="clearer"></div>
          </Wrapper>
          <AgentPanel />
        </Container>
      </PeriodRunProvider>
    </WorkflowChromeProvider>
  );
};

export default observer(Layout);
